import React from 'react'
import Header from './header'
import Footer from './footer'
import { GlobalStyle } from '../style'

function Layout({ children }) {
  return (
    <React.Fragment>
      <Header />
      <main>{children}</main>
      <Footer />
      <GlobalStyle />
    </React.Fragment>
  )
}

export default Layout
